import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41cccded"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "root",
  class: "page-panel"
}
const _hoisted_2 = { class: "panel-inner" }
const _hoisted_3 = {
  class: "panel-logo",
  "data-transition-enter": "fade"
}
const _hoisted_4 = { class: "panel-title" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  class: "panel-meta",
  "data-transition-enter": "fade-up"
}
const _hoisted_7 = { class: "last-update" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  class: "panel-close",
  "data-transition-enter": "fade"
}

import {
  onMounted,
  nextTick,
  ref,
  onBeforeUnmount,
  computed,
} from "vue";
import { useI18n } from "vue-i18n";
import { pagePanelId, usePagePanels } from "@/services/stores/page-panels";

import gsap from "gsap";

import SimpleScrollbar from "simple-scrollbar";
import "simple-scrollbar/simple-scrollbar.css";
import { useAppState } from "@/services/composition";


export default /*#__PURE__*/_defineComponent({
  emits: ["redirect", "close"],
  setup(__props, { emit }: { emit: ({
  (e: "redirect", slug: string): void;
  (e: "close"): void;
}), expose: any, slots: any, attrs: any }) {

const { t } = useI18n();
const { state, send } = useAppState()
const { findPage } = usePagePanels();

const panel = ref(null);

const pagePanelSlug = computed(() => {
  return state.value.context.pagePanelId || null
})

const slug = computed(() => {
  return pagePanelSlug.value
});

const content = computed(() => {
  const page = findPage(pagePanelSlug.value);
  return page ? page.content : [];
});

const onEnter = (el: gsap.DOMTarget, onComplete: gsap.Callback) => {
  const $ = gsap.utils.selector(el);
  const tl = gsap.timeline({ onComplete });
  tl.fromTo(
    el,
    {
      opacity: 0,
    },
    {
      opacity: 1,
      duration: 0.5,
      ease: "quint.in",
    },
    "start"
  );
  tl.from(
    panel.value,
    { yPercent: 50, duration: 1, ease: "quint.inOut" },
    "start"
  );
  tl.from(
    $('[data-transition-enter="fade"]'),
    { opacity: 0, duration: 1, stagger: 0.1, ease: "quint.inOut" },
    "start+=0.1"
  );
  tl.from(
    $('[data-transition-enter="fade-up"]'),
    {
      opacity: 0,
      yPercent: 100,
      duration: 1,
      stagger: 0.1,
      ease: "quint.inOut",
    },
    "start+=0.2"
  );
  tl.from(
    $('[data-transition-enter="fade-right"]'),
    {
      opacity: 0,
      xPercent: -100,
      duration: 1,
      stagger: 0.1,
      ease: "quint.inOut",
    },
    "start+=0.2"
  );
};

const onLeave = (el: gsap.DOMTarget, onComplete: gsap.Callback) => {
  const tl = gsap.timeline({ onComplete });
  tl.to(el, {
    opacity: 1,
    duration: 0.3,
    ease: "quint.out",
  });
};

const scroller = ref(null);
const noScrollBar = ref(false);

const getScrollWidth = () => {
  var outer = document.createElement("div");
  var inner = document.createElement("div");
  outer.style.width = inner.style.width = "100%";
  outer.style.overflow = "scroll";
  document.body.appendChild(outer).appendChild(inner);
  var scroll_width = outer.offsetWidth - inner.offsetWidth;
  outer.parentNode.removeChild(outer);
  return scroll_width;
};

onMounted(async () => {
  await nextTick();

  if (scroller.value) {
    SimpleScrollbar.initEl(scroller.value);
    const scrollWidth = getScrollWidth();
    const scrollContainer = scroller.value.querySelector(
      ".ss-content"
    ) as HTMLElement;
    if (scrollWidth === 0) {
      scrollContainer.style.width = "100%";
      noScrollBar.value = true;
    }
  }

  const redirectLink: HTMLAnchorElement[] = Array.from(
    scroller.value.querySelectorAll("a.redirect-terms")
  );
  redirectLink.forEach((link) => {
    link.addEventListener("click", redirectToTerms);
  });
});

onBeforeUnmount(() => {
  const redirectLink: HTMLAnchorElement[] = Array.from(
    scroller.value.querySelectorAll("a.redirect-terms")
  );
  redirectLink.forEach((link) => {
    link.removeEventListener("click", redirectToTerms);
  });
});



const redirectToTerms = (event: MouseEvent) => {
  event.preventDefault();
  emit("redirect", "terms");
};

return (_ctx: any,_cache: any) => {
  const _component_ui_icon = _resolveComponent("ui-icon")!
  const _component_ui_btn_icon = _resolveComponent("ui-btn-icon")!

  return (_openBlock(), _createBlock(_Transition, {
    css: false,
    onEnter: onEnter,
    onLeave: onLeave,
    appear: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "backdrop",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }),
        _createElementVNode("div", {
          class: "panel",
          ref_key: "panel",
          ref: panel
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_ui_icon, { name: "logo-brand" })
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                innerHTML: _unref(t)(`${_unref(slug)}.page_title`),
                "data-transition-enter": "fade-right"
              }, null, 8, _hoisted_5)
            ]),
            (_unref(content) && _unref(content).length > 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["panel-body", { noScrollBar: noScrollBar.value }])
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)(`${_unref(slug)}.last_update`)), 1)
                  ]),
                  _createElementVNode("div", {
                    class: "panel-content",
                    "data-transition-enter": "fade",
                    ref_key: "scroller",
                    ref: scroller
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(content), (item, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "panel-content-item",
                        innerHTML: _unref(t)(`${_unref(slug)}.${item}`)
                      }, null, 8, _hoisted_8))
                    }), 128))
                  ], 512)
                ], 2))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_ui_btn_icon, {
                variant: "secondary",
                color: "dark-red",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
                class: "icon",
                name: "crossmark"
              })
            ])
          ])
        ], 512)
      ], 512)
    ]),
    _: 1
  }))
}
}

})